<template>
  <div class="napaLists" style="margin-top: 24px;">
    <div
      class="napaItem"
      v-for="(item, index) in applicationReceivedList"
      :key="index"
      @click="() => handleClickItem(item)"
      :style="{
        'background-color': item.type === 'research' ? '#FFFBFB' : '#FAFEFF',
      }"
    >
      <div style="display: flex; width: 100%; align-items: center;">
        <figure class="napaItemImage">
          <img :src="item.img" alt="" width="100%" />
        </figure>
        <div class="napaItemText">
          <div>
            <h6
              class="napaItemTitle"
              :style="{ color: item.type == 'research' ? '#502423' : '' }"
            >
              {{ item.title }}
            </h6>
            <h3
              class="napaItemDesc"
              style="display: flex; align-items: center; flex-wrap: wrap;"
              :style="{ color: item.type == 'research' ? '#502423' : '' }"
            >
              {{ item.desc }}
              <span
                v-if="item.type == 'research'"
                class="chip-user"
                :style="{
                  'background-color': item.status == 2 ? '#B6CEA4' : '#D3ACAC',
                }"
                >연구자</span
              >
            </h3>
            <h6 class="napaItemTime">2023.01.23 PM 11:21</h6>
          </div>
          <MainBadge
            :title="getBtnLabel(item.status)"
            :variant="getBadgeVariant(item.status)"
          />
        </div>

        <div class="btn-action">
          <div>
            <MainButton
              size="large"
              btnText="신청서 보기"
              variant="contained"
            />
            <button
              class="btn-outlined"
              @click="(e) => handleClickItemButtonDelete(e, item)"
            >
              삭제하기
            </button>
          </div>
        </div>
      </div>

      <div class="btn-action-mobile">
        <MainButton size="large" btnText="신청서 보기" variant="contained" />
        <button
          class="btn-outlined"
          @click="(e) => handleClickItemButtonDelete(e, item)"
        >
          삭제하기
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import MainBadge from "@/components/badge/MainBadge.vue";
import MainButton from "@/components/button/MainButton.vue";

export default {
  name: "ApplicationReceivedItem",
  components: { MainButton, MainBadge },
  props: {
    items: Array,
    handleClickItem: Function,
    handleClickItemButtonDelete: Function,
  },
  data() {
    return {
      applicationReceivedList: [
        {
          title: "보낸 기업",
          desc: "(주)행복을 만드는 사람들",
          date: "2023.01.23 PM 11:21",
          status: 0, // waiting for approval
          img: "/images/manager/matching/matching1.png",
          type: "user",
        },
        {
          title: "보낸 기업",
          desc: "(주)행복을 만드는 사람들",
          date: "2023.01.23 PM 11:21",
          status: 0, // waiting for approval
          img: "/images/manager/matching/matching1.png",
          type: "research",
        },
        {
          title: "보낸 기업",
          desc: "(주)행복을 만드는 사람들",
          date: "2023.01.23 PM 11:21",
          status: 1, // Advisory completed
          type: "user",
          img: "/images/manager/matching/matching1.png",
        },
        {
          title: "보낸 기업",
          desc: "(주)행복을 만드는 사람들",
          date: "2023.01.23 PM 11:21",
          status: 1, // Advisory completed
          type: "research",
          img: "/images/manager/matching/matching1.png",
        },
        {
          title: "보낸 기업",
          desc: "(주)행복을 만드는 사람들",
          date: "2023.01.23 PM 11:21",
          status: 2, //  decline approval
          type: "user",
          img: "/images/manager/matching/matching1.png",
        },
        {
          title: "보낸 기업",
          desc: "강 감 찬",
          date: "2023.01.23 PM 11:21",
          status: 0, // waiting for approval
          type: "research",
          img: "/images/manager/matching/matching3.png",
        },
        {
          title: "보낸 사람",
          desc: "강 감 찬",
          date: "2023.01.23 PM 11:21",
          status: 2, // decline approval
          img: "/images/manager/matching/matching3.png",
          type: "research",
        },
      ],
    };
  },

  computed: {
    getBadgeVariant() {
      return function(status) {
        switch (status) {
          case 0:
            return "green";
          case 1:
            return "blue";
          case 2:
            return "red";
          default:
            return "green";
        }
      };
    },
    getBtnLabel() {
      return function(status) {
        switch (status) {
          case 0:
            return "승인 대기";
          case 1:
            return "승인 완료";
          case 2:
            return "승인 거절";
          default:
            return "승인 대기";
        }
      };
    },
  },
};
</script>
<style lang="scss" scoped>
// Section 2

.btn-outlined {
  height: 48px;
  border: 1px solid #989898;
  background-color: #fff;
  font-size: 2.1rem;
  margin-top: 16px;
  cursor: pointer;
  width: 100%;
}

.chip-user {
  font-size: 1.4rem;
  padding: 4px 8px;
  border-radius: 4px;
  color: #fff;
  margin-left: 4px;
}
</style>
